// TeamData.js

const teamData = [
  {
    name: 'Mareedu Lokesh',
    rollNumber: '20VV1A1235',
    year: '2023-2024',
    socials: {
      linkedin: 'https://www.linkedin.com/in/mareedu-lokesh',
      github: 'https://github.com/mareedulokesh',
      instagram: 'https://instagram.com/mareedulokesh',
      website: 'https://mareedulokesh.com',
      email: 'mailto:mareedulokesh@example.com'
    }
  },
  {
    name: 'Paleti Sowmya',
    rollNumber: '20VV1A1244',
    year: '2023-2024',
    socials: {
      linkedin: 'https://www.linkedin.com/in/paleti-sowmya',
      github: 'https://github.com/paletisowmya',
      instagram: 'https://instagram.com/paletisowmya',
      website: 'https://paletisowmya.com',
      email: 'mailto:paletisowmya@example.com'
    }
  },
  {
    name: 'Rangala Dilleswara Rao',
    rollNumber: '20VV1A1253',
    year: '2023-2024',
    socials: {
      linkedin: 'https://www.linkedin.com/in/rangala-dilleswara-rao',
      github: 'https://github.com/rangaladilleswararao',
      instagram: 'https://instagram.com/rangaladilleswararao',
      website: 'https://rangaladilleswararao.com',
      email: 'mailto:rangaladilleswararao@example.com'
    }
  },
  {
    name: 'Tammuluri Lokesh',
    rollNumber: '20VV1A1258',
    year: '2023-2024',
    socials: {
      linkedin: 'https://www.linkedin.com/in/tammuluri-lokesh',
      github: 'https://github.com/tammulurilokesh',
      instagram: 'https://instagram.com/tammulurilokesh',
      website: 'https://tammulurilokesh.com',
      email: 'mailto:tammulurilokesh@example.com'
    }
  }
];

export default teamData;

